<p
  [innerHtml]="field?.message != null ? field.message : ''"
  [class]="field?.messageClass"
></p>
